import React from 'react'
import ManageItems from '../manage-form';
import ManageItemsCategory from './manage-items-category';

const ManageCategory: React.FC = () => {
    return <ManageItemsCategory title="Danh mục" />;
};

export default ManageCategory
